import { memo } from 'react';
import { Alert, Box, Button, Modal, SpaceBetween, TextContent } from '@amzn/awsui-components-core';

import { ContentPageTree } from './ContentPageTree';
import { EditPageButtonViewModel } from './EditPageButtonViewModel';

interface EditPageModalProps {
  readonly vm: EditPageButtonViewModel;
}

/** Modal for managing page hierarchy and order within a Guide document. */
const EditPageModal = memo(function EditPageModal({ vm }: EditPageModalProps) {
  return (
    <Modal
      visible
      header="Re-order Pages"
      onDismiss={vm.dismissModal}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={vm.dismissModal}>
              Cancel
            </Button>
            <Button variant="primary" loading={vm.isSaving} onClick={vm.confirmReorder}>
              Apply
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <TextContent>
          <p>Select a page and use the up/down buttons to re-order:</p>
        </TextContent>
        <SpaceBetween direction="horizontal" size="xs">
          <Button iconName="caret-up-filled" disabled={!vm.isMoveUpEnabled} onClick={vm.moveUp}>
            Move up
          </Button>
          <Button
            iconName="caret-down-filled"
            disabled={!vm.isMoveDownEnabled}
            onClick={vm.moveDown}
          >
            Move down
          </Button>
          <Button
            iconName="caret-right-filled"
            disabled={!vm.isMoveIntoEnabled}
            onClick={vm.moveInto}
          >
            Move into next
          </Button>
        </SpaceBetween>
        {vm.pages.length > 0 && (
          <ContentPageTree
            pages={vm.pages}
            selectedNode={vm.selectedPage}
            onSelectedNodeChainChanged={vm.selectPage}
            initialTreeState="expand-all"
          />
        )}
        {vm.reorderErrorMessage !== undefined && (
          <Alert type="error">{vm.reorderErrorMessage}</Alert>
        )}
      </SpaceBetween>
    </Modal>
  );
});

export default EditPageModal;
